import { Card, Radio, Select, Tooltip, Row, Col, Divider, Alert, Input } from 'antd';
import { FaClipboardCheck, FaCheckCircle, FaTimesCircle, FaMapMarkerAlt, FaQuestionCircle } from 'react-icons/fa';
import { getMotivoIcon } from '../components/IconUtils';

const { TextArea } = Input;

const EligibilityStep = ({
  estadoLlamadaId,
  esElegible,
  setEsElegible,
  bloquearElegibilidad,
  motivoNoElegibleId,
  setMotivoNoElegibleId,
  departamentoFueraTerritorio,
  municipioFueraTerritorio,
  setDepartamentoFueraTerritorio,
  setMunicipioFueraTerritorio,
  observacionNoElegible,
  setObservacionNoElegible,
  motivosNoElegible,
  departamentos,
  municipios,
  handleDepartamentoChange,
  // Nuevos props simplificados
  motivosOtro,
  motivoOtroSeleccionadoId,
  setMotivoOtroSeleccionadoId,
  motivoOtroOtro,
  setMotivoOtroOtro
}) => {

  const ocultarOpcion =
    bloquearElegibilidad && esElegible !== null;

  const motivoSeleccionado = motivosNoElegible?.find(
    m => m.id === motivoNoElegibleId
  );

  const requiereUbicacion =
    motivoSeleccionado?.requiere_ubicacion === 1 ||
    motivoSeleccionado?.requiere_ubicacion === true;

  const observacionInvalida =
    esElegible === false &&
    (!observacionNoElegible || observacionNoElegible.trim() === '');

  // Validaciones para motivo "Otro"
  const esMotivoOtro = motivoSeleccionado?.codigo === 'OTRO';
  const motivoOtroSeleccionado = motivosOtro?.find(m => m.id === motivoOtroSeleccionadoId);
  const motivoOtroCualInvalido = esMotivoOtro && 
    motivoOtroSeleccionado?.codigo === 'CUAL' && 
    (!motivoOtroOtro || motivoOtroOtro.trim() === '');

  return (
    <Card
      size="small"
      style={{ marginBottom: 20, borderLeft: '4px solid #52c41a' }}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FaClipboardCheck style={{ color: '#52c41a' }} />
          <span>Evaluación de Elegibilidad</span>
        </div>
      }
    >
      <div style={{ marginBottom: 16 }}>
        <strong style={{ display: 'block', marginBottom: 12 }}>
          ¿El participante es elegible? *
        </strong>
        {bloquearElegibilidad && (
          <Alert
            message="Elegibilidad definida automáticamente"
            description="Al seleccionar 'No Continúa', el participante queda marcado automáticamente como No Elegible."
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Radio.Group
          value={esElegible}
          disabled={bloquearElegibilidad}
          onChange={(e) => {
            if (bloquearElegibilidad) return;

            setEsElegible(e.target.value);

            if (e.target.value === true) {
              setMotivoNoElegibleId(null);
              setObservacionNoElegible("");
              // Limpiar campos de motivo "Otro"
              setMotivoOtroSeleccionadoId(null);
              setMotivoOtroOtro("");
            }
          }}
          buttonStyle="solid"
        >
          {(!ocultarOpcion || esElegible === true) && (
            <Radio.Button
              value={true}
              style={{
                backgroundColor: '#f6ffed',
                borderColor: '#b7eb8f',
                color: '#000'
              }}
            >
              <FaCheckCircle style={{ color: '#52c41a', marginRight: 8 }} />
              Sí, es elegible
            </Radio.Button>
          )}

          {(!ocultarOpcion || esElegible === false) && (
            <Radio.Button
              value={false}
              style={{
                backgroundColor: '#fff2f0',
                borderColor: '#ffccc7',
                color: '#ff4d4f'
              }}
            >
              <FaTimesCircle style={{ color: '#ff4d4f', marginRight: 8 }} />
              No es elegible
            </Radio.Button>
          )}
        </Radio.Group>
      </div>
      
      {estadoLlamadaId === 2 && esElegible === null && (
        <Alert
          message="Estado Verificado"
          description="Para el estado 'Verificado' se espera que el participante sea elegible."
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      
      {esElegible === false && (
        <div style={{ padding: 16, backgroundColor: '#fff2f0', borderRadius: 6 }}>
          <strong style={{ display: 'block', marginBottom: 12 }}>
            Motivo de no elegibilidad *
          </strong>
          <Select
            placeholder="Seleccione el motivo"
            style={{ width: "100%", marginBottom: 16 }}
            value={motivoNoElegibleId}
            onChange={(value) => {
              setMotivoNoElegibleId(value);
              // Limpiar selección de motivo "Otro" cuando cambia el motivo principal
              setMotivoOtroSeleccionadoId(null);
              setMotivoOtroOtro("");
            }}
            optionLabelProp="label"
          >
            {motivosNoElegible
              .filter(m => m.activo)
              .map(motivo => (
                <Select.Option
                  key={motivo.id}
                  value={motivo.id}
                  label={motivo.nombre}
                >
                  <Tooltip title={motivo.descripcion}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {getMotivoIcon(motivo.codigo)}
                      <span>{motivo.nombre}</span>
                      {motivo.descripcion && (
                        <FaQuestionCircle style={{ color: '#999', marginLeft: 'auto' }} />
                      )}
                    </div>
                  </Tooltip>
                </Select.Option>
              ))}
          </Select>
          
          {/* Select para opciones de "Otro" */}
          {esMotivoOtro && (
            <div style={{ marginBottom: 16 }}>
              <strong style={{ display: 'block', marginBottom: 8 }}>
                Seleccione un motivo específico *
              </strong>
              
              <Select
                placeholder="Seleccione una opción"
                style={{ width: "100%", marginBottom: 8 }}
                value={motivoOtroSeleccionadoId}
                onChange={(value) => {
                  setMotivoOtroSeleccionadoId(value);
                  // Limpiar el campo de texto si no se selecciona "¿Cuál?"
                  if (value) {
                    const motivoSeleccionado = motivosOtro.find(m => m.id === value);
                    if (motivoSeleccionado?.codigo !== 'CUAL') {
                      setMotivoOtroOtro("");
                    }
                  } else {
                    setMotivoOtroOtro("");
                  }
                }}
                optionLabelProp="label"
              >
                {motivosOtro.map(motivo => (
                  <Select.Option
                    key={motivo.id}
                    value={motivo.id}
                    label={motivo.nombre}
                  >
                    <Tooltip title={motivo.descripcion}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {getMotivoIcon(motivo.codigo)}
                        <span>{motivo.nombre}</span>
                        {motivo.descripcion && (
                          <FaQuestionCircle style={{ color: '#999', marginLeft: 'auto' }} />
                        )}
                        
                        
                   
                      </div>
                    </Tooltip>
                  </Select.Option>
                ))}
              </Select>
              
              {/* Campo de texto solo para "¿Cuál?" */}
              {motivoOtroSeleccionado?.codigo === 'CUAL' && (
                <div style={{ marginTop: 8 }}>
                  <Input
                    placeholder="Especifique el motivo..."
                    value={motivoOtroOtro}
                    onChange={(e) => setMotivoOtroOtro(e.target.value)}
                    style={{ width: "100%" }}
                    status={motivoOtroCualInvalido ? 'error' : ''}
                  />
                  {motivoOtroCualInvalido && (
                    <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 4 }}>
                      Debe especificar el motivo
                    </div>
                  )}
                  <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
                    Describa en detalle el motivo específico de no elegibilidad.
                  </div>
                </div>
              )}
              
              {/* Mensaje de validación */}
              {!motivoOtroSeleccionadoId && (
                <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 8 }}>
                  Debe seleccionar una opción
                </div>
              )}
            </div>
          )}
          
          {requiereUbicacion && (
            <>
              <Divider />
              <strong style={{ display: 'block', marginBottom: 12 }}>
                <FaMapMarkerAlt style={{ marginRight: 8, color: '#ff4d4f' }} />
                Ubicación fuera del territorio *
              </strong>

              <Row gutter={12}>
                <Col span={12}>
                  <Select
                    placeholder="Departamento"
                    style={{ width: "100%" }}
                    value={departamentoFueraTerritorio}
                    onChange={handleDepartamentoChange}
                    options={departamentos.map(d => ({
                      label: d.departamento,
                      value: d.oid
                    }))}
                  />
                </Col>
                <Col span={12}>
                  <Select
                    placeholder="Municipio"
                    style={{ width: "100%" }}
                    value={municipioFueraTerritorio}
                    onChange={setMunicipioFueraTerritorio}
                    disabled={!departamentoFueraTerritorio}
                    options={municipios.map(m => ({
                      label: m.municipio,
                      value: m.oid
                    }))}
                  />
                </Col>
              </Row>
            </>
          )}
          
          <div style={{ marginTop: 16 }}>
            <strong style={{ display: 'block', marginBottom: 8 }}>
              Observación específica <span style={{ color: '#ff4d4f' }}>*</span>
            </strong>
            <TextArea
              rows={3}
              placeholder="Describa los detalles del motivo de no elegibilidad..."
              value={observacionNoElegible}
              onChange={(e) => setObservacionNoElegible(e.target.value)}
              status={observacionInvalida ? 'error' : ''}
            />
            {observacionInvalida && (
              <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 4 }}>
                Este campo es obligatorio
              </div>
            )}
          </div>
        </div>
      )}
    </Card>
  );
};

export default EligibilityStep;